<template>
  <el-dialog
    title="修改商户信息"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="editStoreInfo" label-width="120px">
      <el-form-item label="商户名称">
        <el-input 
          v-model="editStoreInfo.name" 
          placeholder="商户名称不能修改" 
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="商户地址" prop="address">
        <el-input 
          v-model="editStoreInfo.address" 
          placeholder="必填，请填写商户地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="tel">
        <el-input 
          v-model="editStoreInfo.tel" 
          placeholder="必填，请填写联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="附近地标" prop="nearByLandmarks">
        <el-input 
          v-model="editStoreInfo.nearByLandmarks" 
          placeholder="必填，请填写附近地标"
        ></el-input>
      </el-form-item>
      <el-form-item label="地区 x坐标">
        <el-input 
          v-model="editStoreInfo.mapX" 
          placeholder="选择填，请填写x坐标"
        ></el-input>
      </el-form-item>
      <el-form-item label="地区 y坐标">
        <el-input 
          v-model="editStoreInfo.mapY" 
          placeholder="选填，请填写y坐标"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitEditStoreInfo">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateStoreInfo } from '@/api/common/storeInfoManage/storeInfoManageApi'

export default {
  name: 'EditStoreInfo',
  data() {
    return {
      dialogVisible: false,
      editStoreInfo: {
        storeId: '',
        name: '',
        address: '',
        tel: '',
        nearByLandmarks: '',
        mapX: '',
        mapY: ''
      }
    }
  },
  methods: {
    open(storeInfo) {
      this.refreshEditStoreInfo(storeInfo)
      this.dialogVisible = true
    },
    refreshEditStoreInfo(storeInfo) {
      this.editStoreInfo = {
        storeId: storeInfo.storeId,
        name: storeInfo.name,
        address: storeInfo.address,
        tel: storeInfo.tel,
        nearByLandmarks: storeInfo.nearByLandmarks,
        mapX: storeInfo.mapX,
        mapY: storeInfo.mapY
      }
    },
    handleClose() {
      this.clearEditStoreInfo()
    },
    clearEditStoreInfo() {
      this.editStoreInfo = {
        storeId: '',
        name: '',
        address: '',
        tel: '',
        nearByLandmarks: '',
        mapX: '',
        mapY: ''
      }
    },
    editStoreValidate() {
      if (!this.editStoreInfo.address) {
        this.$message.error('商户地址必填')
        return false
      }
      if (!this.editStoreInfo.tel) {
        this.$message.error('联系电话必填')
        return false
      }
      if (!this.editStoreInfo.nearByLandmarks) {
        this.$message.error('附近地标必填')
        return false
      }
      return true
    },
    submitEditStoreInfo() {
      if (!this.editStoreValidate()) return
      
      updateStoreInfo(this.editStoreInfo)
        .then(() => {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.$emit('refresh')
        })
        .catch(error => {
          console.error('修改失败', error)
        })
    }
  }
}
</script>